/* Native storage for CCM products without a V3 preview coordinator. */
(function () {
  function mount(root) {
    if (root.dataset.nativeAccessoryMounted) return;
    const form = document.getElementById(root.dataset.productFormId);
    if (!form || form.closest('product-info')?.querySelector('ccm-live-preview-v3')?.isActive) return;
    root.dataset.nativeAccessoryMounted = 'true';
    const button = root.querySelector('.theme-button-secondary');
    const host = form.closest('product-form');
    const error = document.createElement('p'); error.setAttribute('role', 'alert'); error.hidden = true;
    root.append(error);
    let handedOff = false;
    let asset, choosing = false, submitting = false, allowSubmit = false, legacyClick = false, generation = 0;
    const report = message => { error.textContent = message; error.hidden = !message; };
    const property = (name, value) => {
      let field = form.querySelector(`[name="properties[${name}]"]`);
      if (!field) { field = document.createElement('input'); field.type = 'hidden'; field.name = `properties[${name}]`; form.append(field); }
      field.value = value;
    };
    const nativePhoto = () => {
      try {
        const url = new URL(form.querySelector('[name="properties[Photo]"]')?.value || '');
        const match = /^\/f\/([a-f0-9-]{36})\/[a-f0-9]{64}\/production\.jpg$/.exec(url.pathname);
        return url.protocol === 'https:' && url.hostname === 'p.crystalclearmemories.com' && match ? {asset_id:match[1],url:url.href} : null;
      } catch (_) { return null; }
    };
    root.addEventListener('click', async event => {
      if (!event.target.closest('.theme-button-secondary') || legacyClick) return;
      event.preventDefault(); event.stopImmediatePropagation();
      if (choosing || submitting) return;
      choosing = true; report(''); const selectedGeneration = generation;
      try {
        if (!await window.CustomerMedia.enabled()) throw new Error('Photo upload is unavailable. Please retry.');
        const choice = await window.CustomerMedia.choose();
        if (!choice || selectedGeneration !== generation) return;
        asset = choice.asset;
        property('Photo', asset.url); property('_Photo', asset.url); property('_media_asset_id', asset.asset_id);
        form.querySelector('[name="properties[_media_order_receipt]"]')?.remove();
        const image = document.createElement('img'); image.src = asset.thumbnail_url; image.alt = 'Your selected photo';
        root.querySelector('.drop-area').replaceChildren(image); button.textContent = 'Change photo';
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.filestackFileChoiced, {data:{url:asset.url,filename:choice.file.name,mimetype:'image/jpeg',size:asset.bytes},formId:form.getAttribute('id')});
      } catch (failure) { report(failure.message || 'Your photo could not be saved. Please retry.'); }
      finally { choosing = false; }
    }, true);
    document.addEventListener('ccm:photo-later-selected', event => {
      if (event.detail.formId !== form.getAttribute('id')) return;
      generation++; asset = null;
      ['_media_asset_id','_media_order_receipt'].forEach(name => form.querySelector(`[name="properties[${name}]"]`)?.remove());
      report('');
    });
    form.addEventListener('submit', async event => {
      if (allowSubmit) { allowSubmit = false; return; }
      const current = nativePhoto();
      if (!current && !choosing) return; // Existing legacy and photo-later paths.
      event.preventDefault(); event.stopImmediatePropagation();
      if (choosing || submitting) return;
      submitting = true; handedOff = false; report(''); const selectedGeneration = generation, submitter = event.submitter;
      host?.setSubmissionLoading?.(true, 'Adding…', {lock:false});
      try {
        asset = current;
        const cart = await window.StorefrontRequest.json(`${window.routes?.root || '/'}cart/update.js`, {method:'POST',body:'{}',credentials:'same-origin',cache:'no-store',headers:{Accept:'application/json','Content-Type':'application/json'}},{timeoutMs:30000});
        const verified = await window.CustomerMedia.associate(asset, cart.token);
        if (selectedGeneration !== generation) return;
        if (verified.asset_id !== asset.asset_id || !/^[a-f0-9]{64}$/.test(verified.order_receipt || '')) throw new Error('Your photo could not be verified. Please retry.');
        property('Photo', verified.url); property('_Photo', verified.url); property('_media_asset_id', verified.asset_id); property('_media_order_receipt', verified.order_receipt);
        await new Promise(resolve => setTimeout(resolve, 0));
        if (selectedGeneration !== generation) return;
        host?.setSubmissionLoading?.(false); allowSubmit = true; handedOff = true; form.requestSubmit(submitter || undefined);
      } catch (failure) { allowSubmit = false; report(failure.message || 'Your photo could not be verified. Please retry.'); }
      finally { if (!handedOff) host?.setSubmissionLoading?.(false); submitting = false; }
    }, true);
  }
  const mountAll = () => document.querySelectorAll('.product-upload-photo').forEach(mount);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mountAll, {once:true}); else mountAll();
  document.addEventListener('shopify:section:load', mountAll);
})();
